<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="demo-form-inline backborder1" size="small">

        <!-- Pc -->
        <el-form-item class="search-customer-from-pc" v-if="roobot == 'pc'">
          <el-select v-model="search.customer" clearable filterable remote reserve-keyword :remote-method="getCustomer"
            :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="changesellcustomer">
            <el-option v-for="(item, index) in customerLists" :key="index" :label="item.showname"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- h5 -->
        <el-form-item class="search-customer-from-h5" v-if="roobot == 'other'">
          <a class="search-customer-h5" @click="getsearchcustomers">{{ search.customername == '' ? '请输入客户名称 / 电话' :
            search.customername }}</a>
        </el-form-item>

        <el-form-item>
          <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle"
            style="width:100%">
            <template slot="prepend">查找</template>
            <el-button slot="append" icon="el-icon-search" @click="addDialogsinglesearch"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="addmoregoods">添加商品</el-button>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" effect="dark" content="可对下面的商品列表进行拖拽排序" placement="top">
            <el-button :type="showsorttype" :icon="showsorticon" @click="changegoodsort">{{ showsortname }}</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-dropdown>
            <el-button type="warning">
              批量设置仓库
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="settingwarehouse_from_add('all', 2)">商品仓库信息重置</el-dropdown-item>
              <el-dropdown-item @click.native="settingwarehouse_from_add('empty', 2)">未有仓库商品信息设置</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item>
          <el-badge :value="lists.length > 0 ? lists.length : ''" class="item">
            <el-button type="" @click="delcart">清空商品</el-button>
          </el-badge>
        </el-form-item>

      </el-form>

      <div class="cz-sell-order-verifys" style="margin-top:10px;" v-if="roobot == 'other' && search.customername != ''">
        <i></i><span>当前所选择的客户为：{{ search.customername }}</span><a @click="delcustomer"></a>
      </div>
      <div class="cz-sell-order-verifys" style="margin-top:10px;" v-if="isopenaccount == 1">
        <i></i><span>温馨提示：限制开单时使用其它付款账号已开启，当前您只能使用未付款、预存款两种付款方式，如需更改请前往系统设置->基本设置关闭相应的开关</span><a
          @click="Closeaccountwarn"></a>
      </div>




      <!-- 基础数据信息 -->
      <div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
        <div class="cz-sell-base-lists-infos-out">
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">单据编号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input v-model="create.documents" placeholder="单据编号" size="small" :disabled="true"></el-input>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">交货日期</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-date-picker type="date" placeholder="请选择交货日期" v-model="create.deliverdate"
                value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">销售人员</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.seller" filterable placeholder="请选择销售员">
                <el-option v-for="(item, index) in sellerLists" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">经手人员</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.sysmanager" filterable placeholder="请选择经手人">
                <el-option v-for="(item, index) in sysmanagers" :key="index" :label="item.truename"
                  :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">送货方式</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.shipping" filterable placeholder="请选择送货方式">
                <el-option v-for="(item, index) in shippings" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos" v-if="create.shipping == 3">
            <span class="cz-sell-base-lists-infos-title">物流单号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input placeholder="请填写快递单号" v-model="create.shippingcode" style="width:82%"></el-input>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">收款账号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.account" placeholder="未付款" filterable>
                <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">出库备注</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input placeholder="出库备注" v-model="create.note"></el-input>
            </div>
          </div>
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">司机收款</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-checkbox v-model="create.isdriver" />
            </div>
          </div>
        </div>
        <div class="cz-sell-base-lists-infos-goods">
          <el-table :data="lists" :border="true" v-loading="listLoading" show-summary v-if="showsort == 0">
            <el-table-column prop="name" label="商品信息" min-width="300">
              <template slot-scope="scope">
                <span style="float:left;width:100%;font-size:13px;line-height:23px;">{{ scope.row.name }}</span>
                <span style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999"
                  v-if="scope.row.number != ''">编号：{{ scope.row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="数量" current-row-key="getindex" align="center" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="nums[scope.$index]" @input="isChange = true" @blur="changeNum(scope.$index, scope.row)"
                  size="small" style="text-align:center"></el-input>
                <!-- <span @click="changeNumDialog(scope.$index, scope.row)">
                </span> -->
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" min-width="100" align="center">
              <template slot-scope="scope">
                <el-input :value="scope.row.unit" readonly @focus="changeUnit(scope.row)" size="small"
                  style="text-align:center"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="sell" label="售价" align="center" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="sells[scope.$index]" @blur="changesells(scope.$index, scope.row)" size="small"
                  style="text-align:center"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣（%）" current-row-key="getindex" align="center" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="discounts[scope.$index]" @blur="changediscounts(scope.$index, scope.row)"
                  size="small" style="text-align:center"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="dis_sell" label="折后单价" align="center" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="disells[scope.$index]" @blur="changedisells(scope.$index, scope.row)"
                  size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="小计" align="center" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="totals[scope.$index]" @blur="changeTotal(scope.$index, scope.row)"
                  size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="warename" label="仓库" align="center" min-width="120">
              <template slot-scope="scope">
                <el-input :value="scope.row.warename" @focus="changeWare(scope.row)" size="small"
                  v-if="scope.row.type != '虚拟'"></el-input>
                <el-input :value="scope.row.warename" @focus="changeWare(scope.row)" size="small"
                  v-if="scope.row.type == '虚拟'" :disabled="true"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="storageLocationStatus" prop="warename" label="货位/批次" align="center" width="340">
              <template slot-scope="scope">
                <div class="click-ware-lists" @click="switchingBatches(scope.row)">
                  <!--=========================================== 货位/批次点击dom =========================== -->
                  <!--=========================================== 货位/批次点击dom =========================== -->
                  <!--=========================================== 货位/批次点击dom =========================== -->
                  <!--=========================================== 货位/批次点击dom =========================== -->
                  <!--=========================================== 货位/批次点击dom =========================== -->
                  <span v-if="scope.row.batch_info.length == 0">请选择</span>
                  <div v-for="item in scope.row.batch_info" :key="item.storage_location_id">

                    <div>
                      {{ item.full_code }}
                      <span v-if="!batchStatus" style="color: #909399;">
                        [<span style="color: #F56C6C;">{{ item.total }}</span>]
                      </span>
                    </div>

                    <div v-if="batchStatus">
                      <div style="color: #909399;" v-for="batch in item.child" :key="batch.batch_storage_inventory_id">
                        {{ batch.batch_sn }}
                        <span v-if="batch.start_date && batch.end_date">
                          [<span style="color: #F56C6C;">{{ batch.start_date }}至{{ batch.end_date }}</span>]
                        </span>
                        [<span style="color: #F56C6C;">{{ batch.numbers }}</span>]
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="warename" label="类型" align="center" min-width="100">
              <template slot-scope="scope">
                <el-input :value="scope.row.type" @focus="changeType(scope.row)" size="small"
                  v-if="scope.row.type != '虚拟'"></el-input>
                <el-input :value="scope.row.type" @focus="changeType(scope.row)" size="small"
                  v-if="scope.row.type == '虚拟'" :disabled="true"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="备注" align="center" min-width="150">
              <template slot-scope="scope">
                <el-input type="input" v-model="desc[scope.$index]" @blur="changedesc(scope.$index, scope.row)"
                  size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="160" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" @click="copyCurrent(scope.row)" round size="mini">复制</el-button>
                <el-button type="" @click="delCurrent(scope.row)" round size="mini">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 拖拽排序相关-->
          <div class="cz-sell-order-sort" v-if="showsort == 1"
            style="background:rgb(254, 240, 240);border:1px dashed rgb(245, 108, 108);">
            <div style="background:#fef0f0;color:#f56c6c;font-size:12px;padding:10px;width:calc(100% - 20px);">
              温馨提示：正在进行排序，请对下面的商品进行拖拽排序</div>
            <draggable :list="listsorts" :move="getdata" @update="datadragEnd"
              :options="{ animation: 200, handle: '.dargDiv' }">
              <transition-group name="list-complete">
                <div class="dargDiv" v-for="(item, index) in listsorts" :key="index">
                  <div class="cz-sell-order-sort-infos" style="width:calc(7% - 1%);padding:15px 0 15px 1%;">
                    {{ item.brandname }}
                  </div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(8% - 1%);padding:15px 0 15px 1%;">
                    {{ item.number }}
                  </div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(20% - 1%);padding:15px 0 10px 1%;">
                    {{ item.name }}
                  </div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(15% - 1%);padding:15px 0 15px 1%;">
                    {{ item.spec }}
                  </div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(10% - 1%);padding:15px 0 15px 1%;">
                    {{ item.num }} /
                    {{ item.unit }}</div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(10% - 1%);padding:15px 0 15px 1%;">
                    {{ item.sell }}
                  </div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(10% - 1%);padding:15px 0 15px 1%;">
                    {{ item.discount }}%</div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(10% - 1%);padding:15px 0 15px 1%;">
                    {{ item.dis_sell }}
                  </div>
                  <div class="cz-sell-order-sort-infos" style="width:calc(10% - 1%);padding:15px 0 15px 1%;">
                    {{ item.total }}
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>

        <div class="cz-sell-order-stat">
          <div class="cz-sell-order-stat-totals">
            <div style="float:left;width:100%">
              <div class="cz-sell-order-stat-totals-name">
                <span class="cz-sell-order-stat-totals-name-title">订单总额：￥</span>
                <span class="cz-sell-order-stat-totals-name-content">{{ totalprice }}</span>
              </div>
              <div class="cz-sell-order-stat-totals-name">
                <span class="cz-sell-order-stat-totals-name-title">优惠金额：￥</span>
                <el-input placeholder="优惠金额" v-model="create.derate" @blur="changeDerate1" />
              </div>
              <div class="cz-sell-order-stat-totals-name">
                <span class="cz-sell-order-stat-totals-name-title">快递费用：￥</span>
                <el-input placeholder="请填写快递费" v-model="create.express" @blur="changeexpress()" />
              </div>
              <div class="cz-sell-order-stat-totals-name">
                <span class="cz-sell-order-stat-totals-name-title">应付金额：￥</span>
                <span class="cz-sell-order-stat-totals-name-content">{{ create.total }}</span>
              </div>
            </div>
          </div>
          <div class="cz-sell-order-stat-handles">
            <!-- <el-button size="small" type="warning" @click="saveorder" :loading="suresellLoading"
              v-if="create.id == 0 && create.status == 0 && actionauth.order_save == 'true'">保存订单</el-button> -->
            <el-button size="small" type="warning" :disabled="isChange == false" @click="confirmChange" :loading="sellchangeLoading">确认修改</el-button>
            <el-button size="small" type="warning" :disabled="isChange == true" @click="saveverifyorder" :loading="suresellLoading"
              v-if="create.id > 0 && create.status == 0 && actionauth.order_save == 'true'">保存订单</el-button>
            <el-button size="small" type="warning" :disabled="isChange == true" @click="verifyorder" :loading="sellverifyLoading"
              v-if="create.status == 0 && actionauth.order_verify == 'true'">确认审核</el-button>
            <el-button size="small" type="warning" :disabled="isChange == true" @click="verifyorderandprint" :loading="sellverifyprintLoading"
              v-if="create.status == 0 && actionauth.order_verify == 'true'">确认审核并打印</el-button>
            <el-button size="small" type="" :disabled="isChange == true" @click="delorder" :loading="selldelLoading"
              v-if="create.id > 0 && create.status == 0 && actionauth.order_del == 'true'">删除订单</el-button>
          </div>
        </div>
      </div>

      <!---------------------------批量添加--------------------------->
      <el-dialog title="添加产品" :visible.sync="addDialog" width="70%" top="5vh">
        <el-tag type="danger">温馨提示：1、如需设置默认发货仓库请前往系统设置->用户管理，编辑具体的用户选择默认发货仓库。2、鼠标双击可以直接将点击的单个商品直接添加进入购物车。</el-tag>
        <!------------------------search---------------------->
        <el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:15px">
          <el-form-item>
            <el-select v-model="productquery.goodstype" filterable clearable placeholder="按商品类型"
              @change="selectgoodstype">
              <el-option v-for="(item, index) in goodstypelists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="productquery.brandid" filterable clearable placeholder="按品牌" @change="selectbrand">
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-cascader :options="categorylist" clearable v-model="productquery.catid" placeholder="请选择分类"
              @change="selectcate"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select v-model="productquery.warehouse" placeholder="请选择仓库" @change="selectwarehouse">
              <el-option v-for="(item, index) in wareHouseLists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" clearable v-model="productquery.key"
              @keyup.enter.native="getProductList" @change="isnewselect = true" @input="changesearchkey"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="getProductList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="cleargoods">清空勾选</el-button>
          </el-form-item>
        </el-form>

        <!------------------------search end---------------------->
        <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading"
          tooltip-effect="dark" @row-dblclick="rowclick" @row-click="rowclick" @select="handleSelectsingle"
          @select-all="handleSelectall">
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="name" label="商品信息" min-width="300">
            <template slot-scope="scope">
              <span style="float:left;width:100%;font-size:13px;line-height:23px">{{ scope.row.name }}</span>
              <span style="float:left;width:100%;font-size:12px;color:#999999">编号：{{ scope.row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" label="库存类型" min-width="140" align="center">
            <template slot-scope="scope">
              <span style="float:left;width:100%;font-size:13px;line-height:23px">{{ scope.row.goodstype == 0 ? '库存商品' :
                '虚拟商品' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="housename" label="仓库" min-width="140" align="center">
            <template slot-scope="scope">
              <span style="float:left;width:100%;font-size:13px;line-height:23px">{{ scope.row.housename }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="showsell" label="售价" min-width="140" align="center">
            <template slot-scope="scope">
              <span style="float:left;width:100%;font-size:13px;line-height:23px">{{ scope.row.showsell }}</span>
            </template>
          </el-table-column>
          <el-table-column label="可用库存" min-width="140" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.inventory == 0" style="color:#F56C6C">{{ scope.row.inventory }}
                {{ scope.row.unit }}</span>
              <span v-if="scope.row.inventory > 0">{{ scope.row.inventory }} {{ scope.row.unit }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="productPageSizeChange" @current-change="productPageCurrentChange"
            :current-page="productquery.p" :page-sizes="[10, 20, 50]" :page-size="productquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_product_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
        </div>
      </el-dialog>
      <!--------------------------------批量添加end--------------------------->

      <!---------------------------修改单位--------------------------->
      <el-dialog title="单位选择" :visible.sync="unitDialog">
        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
          <el-table-column label="单位" prop="unit"></el-table-column>
          <el-table-column label="售价" prop="sell"></el-table-column>
          <el-table-column label="市场价" prop="market"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeUnitSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--------------------------------修改单位end--------------------------->

      <!---------------------------修改仓库--------------------------->
      <el-dialog title="仓库选择" :visible.sync="wareDialog" width="40%">
        <el-table :data="wareHouseLists" style="width: 100%" v-loading="wareListLoading">
          <el-table-column label="仓库名称" prop="name"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeWareSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--------------------------------修改单位end--------------------------->

      <!---------------------------修改类型--------------------------->
      <el-dialog title="类型选择" :visible.sync="typeDialog" width="40%">
        <el-table :data="typearr" style="width: 100%" v-loading="wareListLoading">
          <el-table-column label="类型名称" prop="name"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeTypeSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--------------------------------修改单位end--------------------------->

      <!--------------------------------打印信息 start ------------------------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
        <div style="width:100%;text-align:right">
          每页展示 <input type="text" v-model="rollpage" v-on:blur="changepagevlaue()"
            style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px" />
          条
          <el-button type="primary" size="mini" circle icon="el-icon-setting" style="margin-left:2%"
            @click="settingprints(printorderdetail)" />
        </div>
        <div id="printContent" v-loading="printLoading">
          <div v-for="(iit, i) in prpage">
            <span style="float:right">{{ iit.id }}/{{ allprintpage }}</span>
            <DIV style="font-size:18px;padding-bottom:2px;margin-bottom:0" align="center" v-if="printsmodel.title == 1">
              <STRONG>{{ printsmodel.titlevalue }}</STRONG>
            </DIV>
            <ul class="titlelists">
              <li v-if="printsmodel.customer_name == 1">客户名称：{{ printorderdetail.customerName }}</li>
              <li v-if="printsmodel.deliverdate == 1">交货日期：{{ printorderdetail.deliverdate }}</li>
              <li v-if="printsmodel.contactname == 1">收货人姓名：{{ printorderdetail.contactname }}</li>
              <li v-if="printsmodel.documents == 1">单据编号：{{ printorderdetail.documents }}</li>
              <li v-if="printsmodel.note == 1">出库备注：{{ printorderdetail.note }}</li>
              <li v-if="printsmodel.contactphone == 1">收货电话：{{ printorderdetail.contactphone }}</li>
              <li v-if="printsmodel.clerkname == 1">销售人员：{{ printorderdetail.clerkName }}</li>
              <li v-if="printsmodel.accountname == 1">支付方式：<span>{{ printorderdetail.accountName }}</span></li>
              <li v-if="printsmodel.address == 1" style="width:100%">收货地址：{{ printorderdetail.address }}</li>
            </ul>

            <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px"
              bordercolor="#333333">
              <TR class="contactcontent">
                <TD v-if="printsmodel.number == 1">
                  <DIV align=center><b>编号</b></DIV>
                </TD>
                <TD v-if="printsmodel.product_name == 1">
                  <DIV align=center><b>品名</b></DIV>
                </TD>
                <TD v-if="printsmodel.product_spec == 1">
                  <DIV align=center><b>规格</b></DIV>
                </TD>
                <TD v-if="printsmodel.unit == 1">
                  <DIV align=center><b>单位</b></DIV>
                </TD>
                <TD v-if="printsmodel.num == 1">
                  <DIV align=center><b>数量</b></DIV>
                </TD>
                <TD v-if="printsmodel.sell == 1">
                  <DIV align=center><b>售价</b></DIV>
                </TD>
                <TD v-if="printsmodel.discount == 1">
                  <DIV align=center><b>折扣</b></DIV>
                </TD>
                <TD v-if="printsmodel.dis_sell == 1">
                  <DIV align=center><b>折后单价</b></DIV>
                </TD>
                <TD v-if="printsmodel.market == 1">
                  <DIV align=center><b>零售价</b></DIV>
                </TD>
                <TD v-if="printsmodel.account == 1">
                  <DIV align=center><b>小计</b></DIV>
                </TD>
                <TD v-if="printsmodel.warehourse == 1">
                  <DIV align=center><b>仓库</b></DIV>
                </TD>
                <TD v-if="printsmodel.desc == 1">
                  <DIV align=center><b>备注</b></DIV>
                </TD>
                <TD v-if="printsmodel.type == 1">
                  <DIV align=center><b>类型</b></DIV>
                </TD>
              </TR>
              <tr v-for="(item, index) in printorderdetail.goods" :key="index" class="contactcontent"
                v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage']">
                <TD v-text="item.number" align="center" v-if="printsmodel.number == 1"></TD>
                <TD v-text="item.name" style="padding-left:1%" v-if="printsmodel.product_name == 1"></TD>
                <TD v-text="item.spec" style="padding-left:1%" v-if="printsmodel.product_spec == 1"></TD>
                <TD v-text="item.unit" align="center" v-if="printsmodel.unit == 1"></TD>
                <TD v-text="item.num" align="center" v-if="printsmodel.num == 1"></TD>
                <TD v-text="item.sell" align="center" v-if="printsmodel.sell == 1"></TD>
                <TD v-text="item.discount" align="center" v-if="printsmodel.discount == 1"></TD>
                <TD v-text="item.dis_sell" align="center" v-if="printsmodel.dis_sell == 1"></TD>
                <TD v-text="item.market" align="center" v-if="printsmodel.market == 1"></TD>
                <TD v-text="item.total" align="center" v-if="printsmodel.account == 1"></TD>
                <TD v-text="item.warename" align="center" v-if="printsmodel.warehourse == 1"></TD>
                <TD v-text="item.desc" style="padding-left:1%" v-if="printsmodel.desc == 1"></TD>
                <TD v-text="item.showtype" align="center" v-if="printsmodel.type == 1"></TD>
              </tr>
              <tr v-if="iit.id == allprintpage">
                <TD align="center" v-if="printsmodel.number == 1 || printsmodel.product_name == 1"><b>合计</b></TD>
                <TD v-if="printsmodel.number == 1 && printsmodel.product_name == 1"></TD>
                <TD v-if="printsmodel.product_spec == 1"></TD>
                <TD v-if="printsmodel.unit == 1">&nbsp;</TD>
                <TD v-if="printsmodel.num == 1" align="center">{{ printorderdetail.allnumber }}</TD>
                <TD v-if="printsmodel.sell == 1">&nbsp;</TD>
                <TD v-if="printsmodel.discount == 1">&nbsp;</TD>
                <TD v-if="printsmodel.dis_sell == 1">&nbsp;</TD>
                <TD v-if="printsmodel.market == 1">&nbsp;</TD>
                <TD align="center" v-if="printsmodel.account == 1">{{ printorderdetail.total }}</TD>
                <TD v-if="printsmodel.warehourse == 1">&nbsp;</TD>
                <TD v-if="printsmodel.desc == 1">&nbsp;</TD>
                <TD v-if="printsmodel.type == 1">&nbsp;</TD>
              </tr>
            </table>
            <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
              <TBODY>
                <TR class="top1">
                  <TD v-if="printsmodel.inputdate == 1"><span>录单日期：{{ printorderdetail.inputdate }}</span></TD>
                  <TD v-if="printorderdetail.verifyername != ''"><span>审核人：{{ printorderdetail.verifyername }}</span>
                  </TD>
                  <TD v-if="printsmodel.sysmanagername == 1"><span>操作人：{{ printorderdetail.sysmanagername }}</span></TD>
                </TR>
                <TR class="top1">
                  <TD v-if="printsmodel.total == 1"><span>应付金额：{{ printorderdetail.real }} 元</span></TD>
                  <TD v-if="printsmodel.isexpress == 1"><span>快递费用：{{ printorderdetail.express }} 元</span></TD>
                  <TD v-if="printsmodel.derate == 1"><span>优惠金额：{{ printorderdetail.derate }} 元</span></TD>
                  <TD v-if="printsmodel.isdriver == 1"><span>是否司机收款：{{ printorderdetail.isdriver == 0 ? '否' : '是'
                      }}</span>
                  </TD>
                </TR>
                <TR class="top1" v-if="printsmodel.print == 1"">
						        <TD :colspan="4"><span>{{ printsmodel.printvalue }}</span></TD>
                </tr>
                <TR class="top2">
                  <TD><span v-if="printsmodel.p_man == 1">配货人</span></TD>
                  <TD><span v-if="printsmodel.s_man == 1">送货人</span></TD>
                  <TD><span v-if="printsmodel.ss_man == 1">收货人</span></TD>
                  <TD>&nbsp;</TD>
                  <TD>&nbsp;</TD>
                </tr>
              </TBODY>
            </TABLE>
            <div class="pageBreak"></div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="closeprint">取 消</el-button>
          <el-button size="medium" type="primary" @click="createnoSave" :loading="printorderLoading">打印订单</el-button>
          <!--<el-button type="danger" @click="cannelorder" :loading="cannelLoading" v-if="printorderdetail.status==1 && actionauth.order_cannel=='true'">撤销审核</el-button>-->
          <!--<el-button type="danger" @click="finishorder" :loading="finishLoading" v-if="printorderdetail.status==1 && actionauth.order_finished=='true'">完成销售单</el-button>-->
        </div>
      </el-dialog>
      <!--------------------------------打印信息 end--------------------------->

      <!-- 客户信息列表 -->
      <el-dialog title="获取客户信息" :visible.sync="mergecustomerDialog" width="55%" top="5vh">
        <el-form :inline="true" size="small">
          <el-form-item><el-input placeholder="请输入关键字" clearable v-model="mergecustomerquery.key"
              @change="mergechange = true" @input="getmergecustomerdata"></el-input></el-form-item>
          <el-form-item><el-button type="primary" icon="el-icon-search" round
              @click="getmergecustomerdata">查询</el-button></el-form-item>
        </el-form>
        <el-table :data="mergecustomerlists" v-loading="mergecustomerquery.loading">
          <el-table-column prop="name" label="客户名称" align="left" />
          <el-table-column prop="phone" label="手机" align="center" />
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="success" size="mini" circle icon="el-icon-check"
                @click="selectcustomer(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="mergepageSizeChange" @current-change="mergepageCurrentChange"
            :current-page="mergecustomerquery.p" :page-sizes="[10, 20, 50]" :page-size="mergecustomerquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="merge_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>

      <div v-if="printsettingDialog" class="printsetting">
        <div class="printmain" :style="printclass">
          <div class="printin" v-loading="printmadequery.loading">
            <div slot="footer" class="dialog-footer" style="float:right">
              <el-button size="mini" @click="closeprinters">取 消</el-button>
              <el-button size="mini" type="primary" @click="saveprintmade">保 存</el-button>
            </div>

            <el-form :inline="true" class="demo-form-inline" size="small"
              style="float:left;width:100%;margin-top:30px;">
              <el-form-item>
                <div style="width:100%;font-size:13px;font-weight:450;line-height:23px">
                  打印模板设置（客户：{{ printmadequery.customername != '' ? printmadequery.customername : '散客' }}）
                </div>
              </el-form-item>
              <template v-for="(item, index) in printmadequery.data">
                <el-form-item label="主体名称" label-width="120" style="float:left;width:100%" v-if="item.id == 83">
                  <el-checkbox v-model="item.isshow" />
                  <el-input type="text" size="small" v-model="item.value" placeholder="请输入打印主体"
                    style="width:85%;margin-left:5%" />
                </el-form-item>
                <el-form-item label="默认设置" label-width="120" style="float:left;width:100%" v-if="item.id == 14">
                  <el-checkbox v-model="item.isshow" />
                  <el-input type="text" size="small" v-model="item.value" placeholder="请输入默认显示设置内容"
                    style="width:85%;margin-left:5%" />
                </el-form-item>
                <el-form-item label="每页条数" label-width="120" style="float:left;width:100%" v-if="item.id == 88">
                  <el-checkbox v-model="item.isshow" />
                  <el-input type="text" size="small" v-model="item.value" placeholder="请输入每页条数"
                    style="width:85%;margin-left:5%" />
                </el-form-item>
                <el-form-item label="客户名称" label-width="120" style="float:left;width:45%" v-if="item.id == 1">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="交货日期" label-width="120" style="float:left;width:45%" v-if="item.id == 2">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="单据编号" label-width="120" style="float:left;width:45%" v-if="item.id == 3">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="支付方式" label-width="120" style="float:left;width:45%" v-if="item.id == 4">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="销售人员" label-width="120" style="float:left;width:45%" v-if="item.id == 5">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="出库备注" label-width="120" style="float:left;width:45%" v-if="item.id == 6">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货姓名" label-width="120" style="float:left;width:45%" v-if="item.id == 7">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货电话" label-width="120" style="float:left;width:45%" v-if="item.id == 8">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货地址" label-width="120" style="float:left;width:45%" v-if="item.id == 9">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="录单日期" label-width="120" style="float:left;width:45%" v-if="item.id == 10">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="优惠金额" label-width="120" style="float:left;width:45%" v-if="item.id == 11">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="实付金额" label-width="120" style="float:left;width:45%" v-if="item.id == 12">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="操作人员" label-width="120" style="float:left;width:45%" v-if="item.id == 13">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="配货人员" label-width="120" style="float:left;width:45%" v-if="item.id == 15">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="送货人员" label-width="120" style="float:left;width:45%" v-if="item.id == 16">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="收货人员" label-width="120" style="float:left;width:45%" v-if="item.id == 87">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="司机收款" label-width="120" style="float:left;width:45%" v-if="item.id == 135">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="快递费用" label-width="120" style="float:left;width:45%" v-if="item.id == 136">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="订单备注" label-width="120" v-if="item.id == 27"
                  style="float:left;width:90%;border-bottom:1px dashed #666666;padding-bottom:10px">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>

                <el-form-item label="商品编号" label-width="120" style="float:left;width:45%" v-if="item.id == 17">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品名称" label-width="120" style="float:left;width:45%" v-if="item.id == 18">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品规格" label-width="120" style="float:left;width:45%" v-if="item.id == 80">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品单位" label-width="120" style="float:left;width:45%" v-if="item.id == 19">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品数量" label-width="120" style="float:left;width:45%" v-if="item.id == 20">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品售价" label-width="120" style="float:left;width:45%" v-if="item.id == 21">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品折扣" label-width="120" style="float:left;width:45%" v-if="item.id == 22">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="折后单价" label-width="120" style="float:left;width:45%" v-if="item.id == 23">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="零售价格" label-width="120" style="float:left;width:45%" v-if="item.id == 24">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品小计" label-width="120" style="float:left;width:45%" v-if="item.id == 25">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="出库仓库" label-width="120" style="float:left;width:45%" v-if="item.id == 26">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
                <el-form-item label="商品类型" label-width="120" style="float:left;width:45%" v-if="item.id == 79">
                  <el-checkbox v-model="item.isshow" />
                </el-form-item>
              </template>
            </el-form>

          </div>
        </div>
      </div>

      <el-dialog title="设置数量" :visible.sync="numberDialogVisible" width="300px" @close="changeNumVlue = 0">
        <el-form>
          <el-form-item prop="number">
            <el-input-number v-model="changeNumVlue" :min="1" :max="99999" :step="1" controls-position="right"
              style="width: 100%"></el-input-number>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="numberDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirm">确 认</el-button>
        </span>
      </el-dialog>

      <ChangeBatch ref="ChangeBatch" :editCode="true" @confirm="batchConfirm" />

    </div>
  </transition>
</template>

<script>
import draggable from 'vuedraggable'
import ChangeBatch from './ChangeBatch.vue';
export default {
  components: { draggable, ChangeBatch },
  props: ['childdata'],
  data() {
    return {
      url: this.GLOBAL.domain + "Sell/index",
      actionauth: '',
      transitionshow: true,
      lists: [],
      isChange: false,
      sellchangeLoading: false,
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        customerid: '',
        searchcustomerid: 1,
        ischangeprice: 0,
        rollpage: 1000, // 页大小
        p: 1,
        carttype: 1,
      },
      search: {
        act: 'barcode',
        token: this.$cookies.get('token'),
        key: '',
        customer: '',
        customername: '',
      },
      customerLoading: false,
      customerLists: [],
      productquery: {
        act: 'inventory',
        token: this.$cookies.get('token'),
        brandid: '',
        catid: '',
        warehouse: '',
        customerid: '',
        key: '',
        goodstype: '',
        carttype: 2,
        orderid: this.childdata.id,
        rollpage: 10, // 页大小
        p: 1
      },
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        deliverdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        id: '',
        account: '',
        documents: '',
        note: '',
        total: 0.00,
        derate: 0.00,
        express: 0.00,
        seller: '',
        customer: '',
        verifyer: '',
        sysmanager: '',
        shipping: '',
        shippingcode: '',
        status: 0,
        'type': 'save',
        'carttype': 2,
        'isdriver': 0,
      },
      showsorttype: 'warning',
      showsorticon: 'el-icon-circle-check-outline',
      showsortname: '启用排序',
      listLoading: false,
      showsort: 0,
      nums: [],
      sells: [],
      discounts: [],
      disells: [],
      totals: [],
      desc: [],
      listsorts: [],
      suresellLoading: false,
      sellverifyLoading: false,
      sellverifyprintLoading: false,
      selldelLoading: false,
      sellerLists: [],
      sysmanagers: [],
      shippings: [
        { id: '1', name: '线下配送' },
        { id: '2', name: '物流' },
        { id: '3', name: '快递' },
        { id: '4', name: '自提' }
      ],
      multipleSelection: [],
      addDialog: false,
      brandlists: [],
      total_product_rows: 0,
      categorylist: [],
      wareHouseLists: [],
      productlists: [],
      addListLoading: false,
      addProductLoading: false,
      nowtime: 0,
      timeoutflag: true,
      defaultwarehouseid: '', //默认发货仓库
      pclickstatus: [],
      unitDialog: false,
      unitlists: [],
      wareDialog: false,
      wareListLoading: false,
      typeDialog: false,
      typearr: [
        { name: '消费' },
        { name: '赠送' },
        { name: '自用' },
        { name: '报废' },
        { name: '欠货' }
      ],
      unitListLoading: false,
      printerDialog: false,
      printLoading: false,
      printorderdetail: [],
      prtotal: 0,
      rollpage: '',
      allprintpage: '',
      printsmodel: [],
      printorderLoading: false,
      goodstypelists: [{ id: 'a0', name: '库存商品' }, { id: '1', name: '虚拟商品' }],
      isopenaccount: 0,

      mergecustomerDialog: false,
      mergecustomerquery: {
        act: 'getmergecustomers',
        token: this.$cookies.get('token'),
        loading: false,
        key: '',
        p: 1,
        rollpage: 10,
      },
      mergechange: false,
      mergecustomerlists: [],
      merge_rows: 0,
      roobot: '',

      printsettingDialog: false,
      printclass: {
        'margin-right': '-20%',
      },

      printmadequery: {
        act: 'saveprintmade',
        id: '',
        customername: '',
        loading: '',
        data: [],
      },
      batchStatus: false,
      storageLocationStatus: false,
      accountLists: [],
      totalprice: 0,
      prpage: [],
      numberDialogVisible: false,
      changeNumVlue: 0,
      currentChangeNum: {
        index: '',
        item: ''
      }
    }
  },

  mounted() {
    this.checkrootbot(); //判断当前设备
    this.query.ischangeprice = 1; //最开始获取要编辑的订单数据时不需要对其价格进行处理
    this.create.id = this.childdata.id; //赋值订单id
    this.getactionauth(); //获取权限设置
    this.addcart(); //新增商品到购物车
    
    this.getSeller(); //获取销售员信息
    this.getopenaccount(); //获取限制使用支付方式功能开关是否开启
    this.getAccount(); //获取收款账号
    this.getSysmanager(); //获取经手人员信息
    this.getdefaultwarehouse(); //获取默认发货仓库
    //this.getprintsmodel(); //获取打印显示模板信息
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
  },

  methods: {
    confirmChange() {
      this.sellchangeLoading = true
      setTimeout(() => {
        this.sellchangeLoading = false
        this.isChange = false
      }, 600)
    },
    handleConfirm() {
      const { index, item } = this.currentChangeNum
      console.log(index, item, '确认事件')
      console.log(this.changeNumVlue, 'this.changeNumVlue')
      this.nums[index] = this.changeNumVlue
      this.$nextTick(() => {
        this.numberDialogVisible = false
        this.changeNum(index, item)
      })
    },
    changeNumDialog(index, item) {
      // 弹出一个dialog弹窗，
      this.changeNumVlue = this.nums[index]
      this.currentChangeNum = {
        index, item
      }
      this.numberDialogVisible = true

    },
    batchConfirm({ id, selection }) {
      this.$axios({
        url: this.GLOBAL.domain + 'Sell/index',
        method: 'post',
        data: {
          act: 'sell_batch_update',
          id: id,
          json_data: JSON.stringify(selection.map(item => {
            return {
              "batch_storage_inventory_id": item.id,
              "numbers": item.numbers
            }
          }))
        }
      })
        .then(res => {
          if (res.Result === 0) {
            this.$message.success('操作成功!');
            this.changeunitid = id
            this.getLists(); //刷新购物车界面
          }
        })
    },
    switchingBatches(row) {
      this.$refs.ChangeBatch.openDialog(row)
    },
    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    selectgoodstype() {
      this.isnewselect = true;
      this.getProductList();
    },
    /** 判断当设备 **/
    checkrootbot() {
      if (this._isMobile()) {
        this.roobot = "other";
      } else {
        this.roobot = "pc";
      }
    },

    /** 获取当前移动设备信息 **/
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|iPad Pro|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },



    /** 获取客户 **/
    getCustomer(query) {
      if (query !== '') {
        this.customerLoading = true;
        var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
        resource.query({ act: 'lists', key: query, token: this.$cookies.get('token'), p: 1, rollpage: 10000000 }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.customerLoading = false;
          } else {
            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
            this.customerLoading = false;
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
          this.customerLoading = false;
        });
      }
    },

    /** 获取默认发货仓库id **/
    getdefaultwarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Manager/index");
      resource.query({ act: 'getdefaultwarehouse', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.defaultwarehouseid = result.warehouseid;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取打印模板设置 **/
    getprintsmodel(id) {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getmodelsetting', id: 1, sellid: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 新增商品到购物车 **/
    addcart() {
      //清空购物车商品
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addcart', id: this.childdata.id, carttype: 2, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.editorder(); //获取购物车里已添加的商品信息
        }
      }).catch((res) => {

      });
    },

    /** 编辑订单信息 **/
    editorder() {
      //清空购物车商品
      var resource = this.$resource(this.url);
      resource.save({ act: 'getorderinfos', id: this.childdata.id, carttype: 2, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          //重置数据    	
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.create.id = result.id;
          this.create.deliverdate = result.deliverdate;
          this.create.account = result.account == 0 ? 0 : result.account;
          this.create.documents = result.documents;
          this.create.note = result.note;
          this.create.derate = result.derate;
          this.create.express = result.express;
          this.create.customer = result.customerid > 0 ? result.customerid : '';
          this.search.customer = result.customerid > 0 ? result.customername : '';
          this.search.customername = result.customername && result.customername != '' ? result.customername : '';

          this.productquery.customerid = result.customerid;
          this.create.sysmanager = result.managerid;
          this.create.shipping = result.shipping;
          this.create.shippingcode = result.shippingcode;
          this.create.verifyer = result.verifyer == 0 ? '' : result.verifyer;
          this.create.seller = result.clerkid;
          this.create.status = result.status;
          this.create.carttype = 2;
          this.create.isdriver = result.isdriver == 1 ? true : false;
          this.query.carttype = 2;
          this.query.customerid = result.customerid > 0 ? result.customerid : '';
          this.getLists();
        }
      }).catch((res) => {

      });
    },

    //获取购物车里已添加的商品信息
    getLists() {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.query.searchcustomerid = 0;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.listsorts = [];
          const _this = this;
          this.lists.forEach(function (e, index) {
            _this.nums.splice(index, 1, e.num);
            _this.totals.splice(index, 1, e.total);
            _this.discounts.splice(index, 1, e.discount);
            _this.sells.splice(index, 1, e.sell);
            _this.disells.splice(index, 1, e.dis_sell);
            _this.desc.splice(index, 1, e.desc);
            _this.isshowtype = e.isshowconsume;

            //获取排序商品信息
            _this.listsorts.push({ id: e.id, number: e.number, name: e.name, spec: e.spec, unit: e.unit, num: e.num, sell: e.sell, discount: e.discount, dis_sell: e.dis_sell, total: e.total, warename: e.warename, type: e.type, brandname: e.brandname });
          });

          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;
          this.query.searchcustomerid = 0;
          this.query.ischangeprice = 0; //关闭修改客户价格开关
          this.getTotal();
          console.log("🚀 ~ resource.query ~ this.lists:", this.lists)
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
        this.query.searchcustomerid = 0;
      });
    },

    /** 获取总价 **/
    getTotal() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'gettotal', derate: this.create.derate, express: this.create.express, carttype: this.query.carttype, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var pricelist = res.data.Message;
          this.totalprice = pricelist.totalprice; //商品总价
          this.create.total = pricelist.realprice; //商品合计
          this.create.derate = pricelist.derate; //优惠金额
          this.create.express = pricelist.express; //快递费

        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 修改客户名称 **/
    changesellcustomer() {
      this.create.customer = this.search.customer;
      this.query.customerid = this.search.customer;
      this.productquery.customerid = this.search.customer;
      this.query.searchcustomerid = 1;
      var clerkid = '';

      //自动根据客户匹配绑定的销售员
      var _this = this;
      this.customerLists.forEach(function (item, i) {
        if (item.id == _this.search.customer) { clerkid = item.clerkid; _this.search.customername = item.name; }
      });
      this.sellerLists.forEach(function (item, i) {
        if (item.id == clerkid) _this.create.seller = clerkid;
      });

      this.getLists(); //刷新购物车界面
    },

    /** 获取销售员 **/
    getSeller() {
      var resource = this.$resource(this.GLOBAL.domain + "Clerk/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
          //默认选择第一个销售员
          //if(this.sellerLists!='') this.create.seller=this.sellerLists[0]['id'];	                      
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取限制支付类型开关状态 **/
    getopenaccount() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getisopenaccount', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.isopenaccount = result.isopenaccount;
        }
      }).catch((res) => {

      });
    },

    /** 获取银行帐户 **/
    getAccount() {
      var resource = this.$resource(this.GLOBAL.domain + "Account/index");
      resource.query({ act: 'limitlists', isdeposit: 1, isnopay: 1, orderid: this.childdata.id, token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取经手人 **/
    getSysmanager() {
      var resource = this.$resource(this.GLOBAL.domain + "Manager/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000, p: 1 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
          this.create.sysmanager = this.$cookies.get('managerid');
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 清空购物车里的商品 **/
    delcart() {
      if (this.showsort == 1) { this.$message.error("请先选择终止排序"); return false; }
      this.$confirm('您确定要清空购物车里的商品，继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delAll', carttype: this.query.carttype, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('清空购物车商品信息成功!');
            this.getLists();
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {

      });
    },

    /** 该条信息在购物车里多复制一条 **/
    copyCurrent(item) {
      this.$confirm('你是否确定要复制 ' + item.name + '商品, 是否继续?', '提示', { type: 'warning' }).then(() => {
        this.multipleSelection = [];
        var goodstype = item.type == '虚拟' ? 1 : 0;
        this.multipleSelection.push({ id: item.productid, warehouse: item.warehouse, price: item.sell, goodstype: goodstype });
        this.addSave();
      }).catch(() => {
        //this.$message.info('已取消操作!');
      });
    },

    /** 商品出库 **/
    addSave() {
      this.addProductLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addproduct', orderid: this.childdata.id, customer: this.search.customer, productid: this.multipleSelection, carttype: this.query.carttype, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addProductLoading = false;
        } else {
          this.$message.success(res.data.Message);
          this.addDialog = false;
          this.addProductLoading = false;
          this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.addDialog = false;
        this.addProductLoading = false;
      });
    },

    /** 删除购物车商品 **/
    delCurrent(item) {
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.name + '!');
            this.getLists();
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        //this.$message.info('已取消操作!');
      });
    },

    //商品拖拽排序
    getdata(evt) {
      console.log(evt.draggedContext.element.id);
    },
    datadragEnd(evt) {
      console.log('拖动前的索引：' + evt.oldIndex);
      console.log('拖动后的索引：' + evt.newIndex);
    },


    /** 点击批量添加商品按钮 **/
    addmoregoods() {
      if (this.showsort == 1) { this.$message.error("请先选择终止排序"); return false; }

      //重置商品搜索  
      this.productquery.brandid = '';
      this.productquery.catid = '';
      this.productquery.key = '';
      this.productquery.warehouse = this.defaultwarehouseid;
      this.productquery.goodstype = '';
      this.productquery.p = 1;
      this.productquery.rollpage = 10;

      //清空已选中的商品
      this.multipleSelection = [];
      this.addDialogShow();
    },

    /** 扫码添加商品信息 **/
    addDialogsingle() {
      this.multipleSelection = [];
      var resource = this.$resource(this.url);
      resource.query({ act: 'sweep', customer: this.search.customer, warehouseid: this.defaultwarehouseid, key: this.productquery.key, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          if (Base64.decode(res.data.Data) == 1) { //有1个以上则展开列表
            this.productquery.warehouse = '';
            this.productquery.goodstype = '';
            this.addDialogShow();
            this.productquery.key = '';
          } else { //扫码解析同一个产品只有1个则直接添加
            this.productquery.warehouse = '';
            this.productquery.goodstype = '';
            this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
            this.addSave();
            this.productquery.key = '';
          }
        }
      }).catch((res) => {

      });
    },

    /** 批量搜索商品 **/
    addDialogsinglesearch() {
      this.multipleSelection = [];
      this.productquery.goodstype = '';
      this.productquery.warehouse = '';
      this.addDialogShow();
    },


    /** 批量添加商品 **/
    addDialogShow() {
      this.addDialog = true;
      this.getWarehouse();
      this.getBrand();
      this.getCategoryList();
      this.getProductList();
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var _this = this;
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.brandlists = [];
          result.forEach(function (e, i) {
            _this.brandlists.push({ id: e.id, name: e.name, py: e.py, showlable: e.showlable });
          });
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取仓库 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取产品分类 **/
    getCategoryList() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 产品信息列表 **/
    getProductList() {
      if (this.isnewselect == true) {
        this.productquery.p = 1;
        this.productquery.rollpage = 10;
      }

      var _this = this;
      this.addListLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.productquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        } else {
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows = parseInt(res.data.count);
          this.checkselectgoods();

          this.pclickstatus = [];
          this.productlists.forEach(function () {
            _this.pclickstatus.push(0);
          });
          this.addListLoading = false;
        }

        if (this.isnewselect == true) this.isnewselect = false;
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.addListLoading = false;
        if (this.isnewselect == true) this.isnewselect = false;
      });
    },

    productPageSizeChange(val) {
      this.productquery.rollpage = val;
      this.getProductList();
    },
    productPageCurrentChange(val) {
      this.productquery.p = val;
      this.getProductList();
    },

    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
      this.isnewselect = true;
      this.getProductList();
    },
    /** 分类搜索（分类发生变化触发一次搜索） **/
    selectcate() {
      this.isnewselect = true;
      this.getProductList();
    },
    /** 仓库搜索（仓库发生变化触发一次搜索） **/
    selectwarehouse() {
      this.isnewselect = true;
      this.getProductList();
    },
    /** 搜索关键字实时刷新数据 **/
    changesearchkey() {
      //网络异常请求加载数据缓慢时禁止向服务器请求加载数据，缓解服务器压力，等上一次数据加载完后再重亲请求加载数据
      if (this.listLoading == true) { return false; }
      this.getProductList();
    },
    //重置已选中的商品
    cleargoods() {
      this.multipleSelection = [];
      //清除勾选的商品信息
      this.$refs.multipleTable.clearSelection();
    },

    /** 点击事件（单击、双击） **/
    rowclick(val, row) {
      this.nowtime++;
      if (this.timeoutflag == false) return false;

      var _this = this;
      this.timeoutflag = false;
      setTimeout(function () {
        if (_this.nowtime == 1) { //单击事件
          _this.selectrow(val, row);
        } else { //双击事件
          _this.selectsingle(val, row);
        }
        _this.nowtime = 0;
        _this.timeoutflag = true;
      }, 250);
    },

    /** 点击单行触发事件 **/
    selectrow(row, event) {
      var _this = this;
      var id = row.id;
      var number = 0;
      var isselect = 0;

      //勾选/取消勾选选中商品信息
      _this.productlists.forEach(function (e, index) {
        if (id == e.id) {
          _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
          number = index;
        }
      });
      //判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品		
      _this.multipleSelection.forEach(function (e, index) { if (id == e.id) isselect = 1 });

      if (isselect == 1) {
        _this.multipleSelection.forEach(function (e, index) { if (id == e.id) _this.multipleSelection.splice(index, 1) });
      } else {
        _this.multipleSelection.push(row);
        //虚拟商品不判断库存是否充足
        if (row.goodstype == 1) return false;

        //异步判断添加的商品是否满足添加的要求（判断商品库存）
        var resource = _this.$resource(_this.url);
        resource.save({ act: 'checkinventorys', product: row, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') _this.$router.push('/login');
            _this.$message.error(res.data.Message);
          } else {
            var data = Base64.decode(res.data.Data);
            if (data == 2) { //库存不足时提示欠货处理
              _this.$confirm(row.name + '库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
                //确认添加按原来的方式，此处不做任何处理
              }).catch(() => {
                //取消操作时，取消勾选的商品
                _this.$refs.multipleTable.toggleRowSelection(_this.productlists[number]);
                //勾选的商品列表里剔除该商品
                _this.multipleSelection.forEach(function (e, index) { if (id == e.id) _this.multipleSelection.splice(index, 1) });
              });
            }
          }
        }).catch((res) => {

        });
      }
    },

    /** 双击单行商品选择添加进购物车 **/
    selectsingle(row, event) {
      var _this = this;
      var id = row.id;
      var number = 0;
      var isselect = 0;

      //勾选/取消勾选选中商品信息
      _this.productlists.forEach(function (e, index) {
        if (id == e.id) {
          _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
          number = index;
        }
      });
      //判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品		
      _this.multipleSelection.forEach(function (e, index) { if (id == e.id) isselect = 1 });

      if (isselect == 1) {
        _this.multipleSelection.forEach(function (e, index) { if (id == e.id) _this.multipleSelection.splice(index, 1) });
      } else {
        _this.multipleSelection.push(row);

        //异步判断添加的商品是否满足添加的要求（判断商品库存）
        var resource = _this.$resource(_this.url);
        resource.save({ act: 'checkinventorys', product: row, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') _this.$router.push('/login');
            _this.$message.error(res.data.Message);
          } else {
            var data = Base64.decode(res.data.Data);
            if (data == 2) { //库存不足时提示欠货处理
              _this.$confirm(row.name + '库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
                //重置信息，添加商品
                _this.multipleSelection = [];
                _this.multipleSelection.push(row);
                //添加商品进购物车
                _this.addSave();

              }).catch(() => {
                //取消操作时，取消勾选的商品
                _this.$refs.multipleTable.toggleRowSelection(_this.productlists[number]);
                //勾选的商品列表里剔除该商品
                _this.multipleSelection.forEach(function (e, index) { if (id == e.id) _this.multipleSelection.splice(index, 1) });
              });
            } else { //库存充足时直接添加进购物车
              //重置信息，添加商品
              _this.multipleSelection = [];
              _this.multipleSelection.push(row);
              //添加商品进购物车
              _this.addSave();
            }
          }
        }).catch((res) => {

        });
      }
    },

    /** 点击每行前面的选择框勾选/取消勾选商品 **/
    handleSelectsingle(val, row) {
      this.isopenselect = false; //关闭全选模式
      var id = row.id;
      var number = 0;
      var isselect = 0;
      var _this = this;

      //获取当前商品在商品列表里的位置
      this.productlists.forEach(function (e, index) { if (id == e.id) number = index });
      //判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
      this.multipleSelection.forEach(function (e, index) { if (id == e.id) isselect = 1 });

      if (isselect == 1) {
        this.multipleSelection.forEach(function (e, index) { if (id == e.id) _this.multipleSelection.splice(index, 1) });
      } else {
        this.multipleSelection.push(row);

        //异步判断添加的商品是否满足添加的要求（判断商品库存）
        var resource = _this.$resource(_this.url);
        resource.save({ act: 'checkinventorys', product: row, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login');
            this.$message.error(res.data.Message);
          } else {
            var data = Base64.decode(res.data.Data);
            if (data == 2) { //库存不足时提示欠货处理
              this.$confirm(row.name + '库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
                //确认添加按原来的方式，此处不做任何处理
              }).catch(() => {
                //取消操作时，取消勾选的商品
                this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
                //勾选的商品列表里剔除该商品
                this.multipleSelection.forEach(function (e, index) { if (id == e.id) _this.multipleSelection.splice(index, 1) });
              });
            }
          }
        }).catch((res) => {

        });
      }
      this.isopenselect = true; //开启全选模式
    },

    //商品全选/全不选
    handleSelectall(val) {
      if (this.isopenselect == false) return false; //关闭点击单行添加数据
      var _this = this;
      var number = 0;
      var sellect = 0;
      var resource = _this.$resource(_this.url);

      //已添加有，删除选中信息
      if (val.length == 0) {
        var ids = [];
        var selectids = [];
        this.productlists.forEach(function (e, index) {
          _this.multipleSelection.forEach(function (ee, i) {
            if (e.id == ee.id) _this.multipleSelection.splice(i, 1);
          });
        });
        return false;
      }

      val.forEach(function (e, index) {
        //异步判断添加的商品是否满足添加的要求（主要判断商品库存）
        resource.save({ act: 'checkinventorys', product: e, token: _this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') _this.$router.push('/login');
            _this.$message.error(res.data.Message);
          } else {
            var data = Base64.decode(res.data.Data);
            if (data == 1) {
              number = 0; sellect = 0;
              _this.multipleSelection.forEach(function (ee, ii) { if (ee.id == e.id) { number = ii; sellect = 1; } });
              sellect == 0 ? _this.multipleSelection.push(e) : '';

            } else if (data == 2) {
              number = 0; sellect = 0;
              //默认勾选选商品
              _this.multipleSelection.forEach(function (ee, ii) { if (ee.id == e.id) { number = ii; sellect = 1; } });
              if (sellect == 0) _this.multipleSelection.push(e);

              _this.$confirm(e.name + '库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
                /**
                _this.multipleSelection.forEach(function(ee,ii) {
                  if(ee.id==e.id) {
                    number=ii;
                    sellect=1;
                  }
                });
                  if(sellect==0) _this.multipleSelection.push(e);
                  */

              }).catch(() => {
                var delselect = 0; var delnumber = 0;
                _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
                _this.multipleSelection.forEach(function (ee, ii) { if (ee.id == e.id) { delnumber = ii; delselect = 1; } });
                if (delselect == 1) _this.multipleSelection.splice(delnumber, 1);
              });
            }

          }
        }).catch((res) => {

        });
      });
    },

    //匹配勾选的商品信息
    checkselectgoods() {
      //提取已选中的商品id
      var _this = this;
      var ids = [];

      this.multipleSelection.forEach(function (e, index) { ids.push(e.id) });
      setTimeout(function () {
        //已添加的商品默认勾选
        _this.productlists.forEach(function (e, i) {
          ids.forEach(function (ee, ii) {
            if (e.id == ee) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[i]);
          });
        });
      }, 100);
    },

    /** 修改单位 **/
    changeUnit(item) {
      this.unitDialog = true;
      this.unitListLoading = true;
      this.changeunitid = item.id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getunit', productid: item.productid, customer: this.search.customer, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
    },

    /** 确认修改单位 **/
    changeUnitSave(item) {
      var _this = this;
      this.unitListLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeunit', orderid: this.create.id, id: item.id, tempid: this.changeunitid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitListLoading = false;
          this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
      this.unitDialog = false;
    },

    /** 修改数量 **/
    changeNum(index, item) {
      this.confirmChange()
      var resource = this.$resource(this.url);
      resource.save({ act: 'changenum', orderid: this.create.id, id: item.id, num: this.nums[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.getLists();
        } else {
          this.getLists();
        }
      }).catch((res) => {

      });
    },

    /** 修改售价 **/
    changesells(index, item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changesells', id: item.id, sells: this.sells[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getLists();
        } else {
          this.getLists();
        }
      }).catch((res) => {

      });
    },

    /** 修改折扣 **/
    changediscounts(index, item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changediscounts', id: item.id, discounts: this.discounts[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getLists();
        } else {
          this.getLists();
        }
      }).catch((res) => {

      });
    },

    /** 修改折后单价 **/
    changedisells(index, item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changedissells', id: item.id, disells: this.disells[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.getLists();
        } else {
          this.getLists();
        }
      }).catch((res) => {

      });
    },

    /** 修改总价 **/
    changeTotal(index, item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changetotal', id: item.id, total: this.totals[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.getLists();
          this.$message.error(res.data.Message);
        } else {
          this.getLists();
        }
      }).catch((res) => {

      });
    },

    /** 修改仓库 **/
    changeWare(item) {
      this.wareDialog = true;
      this.wareListLoading = true;
      this.getWarehouse();
      this.changeunitid = item.id;
      this.wareListLoading = false;
    },

    /** 确认修改仓库 **/
    changeWareSave(item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeware', orderid: this.create.id, id: this.changeunitid, warehouse: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.wareDialog = false;
        } else {
          this.getLists();
          this.wareDialog = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.wareDialog = false;
      });
    },

    /** 修改类型 **/
    changeType(item) {
      this.typeDialog = true;
      this.changeunitid = item.id;
    },

    /** 确认修改类型 **/
    changeTypeSave(item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changetype', orderid: this.create.id, id: this.changeunitid, type: item.name, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.typeDialog = false;
        } else {
          this.getLists();
          this.typeDialog = false;
        }
      }).catch((res) => {
        this.typeDialog = false;
      });
    },

    /** 修改商品备注信息 **/
    changedesc(index, item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changedesc', id: item.id, desc: this.desc[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 修改优惠价 **/
    changeDerate() {
      //检测实付金额是否小于0
      if (this.create.total < 0) {
        this.$message.error("应付金额必须大于0");
        this.create.express = 0.00;
        this.getList();
        return false;
      }

      //检测实付金额是否为自然数
      if (isNaN(this.create.total)) {
        this.$message.error("请填写正确的应付金额");
        this.create.express = 0.00;
        this.getList();
        return false;
      }

      //检测实付金额是否小于快递费用
      if (this.create.total < this.create.express) {
        this.$message.error("应付金额不能小于快递费用");
        this.create.express = 0.00;
        this.getList();
        return false;
      }

      //检测实付金额不能大于订单总额减优惠金额
      /**
      if((this.create.total-this.create.express) != (this.totalprice-this.create.derate)) {
        this.$message.error("应付金额-快递费必须等于合计-优惠金额");
        this.create.express=0.00;
        this.getList();
        return false;
      }
      */

      //优惠金额=订单总价-（应付金额-快递费）    	
      this.create.derate = (this.totalprice - (this.create.total - this.create.express)).toFixed(2);
    },

    /** 修改应付金额 **/
    changeDerate1() {
      //检测优惠金额是否小于0
      if (this.create.derate < 0) {
        this.$message.error("优惠金额不能为0");
        this.create.derate = 0.00;
        this.getList();
        return false;
      }

      //检测优惠金额是否不是数字
      if (isNaN(this.create.derate)) {
        this.$message.error("请输入正确的优惠金额");
        this.create.derate = 0.00;
        this.getList();
        return false;
      }


      //检测优惠金额是否大于商品总额
      /**
      if(this.create.derate > this.totalprice) {
        this.$message.error("优惠金额不能大于合计");
        this.create.derate=0.00;
        this.getList();
        return false;
      }
      */
      //应付金额=订单总价-优惠金额+快递费
      this.create.total = (parseFloat(this.totalprice - this.create.derate) + parseFloat(this.create.express)).toFixed(2);
    },

    /** 修改快递费用 **/
    changeexpress() {
      //检测输入的价格是否小于0
      if (this.create.express < 0) {
        this.$message.error("快递费用不能小于0");
        this.create.express = 0.00;
        this.getList();
        return false;
      }

      if (isNaN(this.create.express)) {
        this.$message.error("请输入正确的快递费");
        this.create.express = 0.00;
        this.getList();
        return false;
      }

      //重新计算应收金额
      this.create.total = (parseFloat(this.totalprice - this.create.derate) + parseFloat(this.create.express)).toFixed(2);
    },

    //启用排序/终止排序
    changegoodsort() {
      if (this.showsort == 0) {
        this.showsort = 1;
        this.showsorttype = '';
        this.showsorticon = 'el-icon-circle-close-outline';
        this.showsortname = '终止排序';
      } else {
        this.showsort = 0;
        this.showsorttype = 'warning';
        this.showsorticon = 'el-icon-circle-check-outline';
        this.showsortname = '启用排序';

        var sortcount = this.listsorts.length;
        var lists = [];
        this.listsorts.forEach(function (e, index) {
          lists.push({ id: e.id, sort: sortcount });
          sortcount--;
        });

        var resource = this.$resource(this.url);
        resource.save({ act: 'changesort', token: this.$cookies.get('token'), sorts: lists }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getLists();
          }
        }).catch((res) => {

        });
      }
    },

    //保存未审核订单
    saveverifyorder() {
      if (this.showsort == 1) { this.$message.error("请先选择终止排序"); return false; }

      this.suresellLoading = true;
      this.create.act = 'verifyorder';
      this.create.type = 'save';
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.suresellLoading = false;
        } else {
          this.$message.success('保存订单信息成功!');
          this.$emit('closechild', 'Selledit'); //关闭窗口			        
        }
      }).catch((res) => {
        this.suresellLoading = false;
      });
    },


    //确认审核订单
    verifyorder() {
      if (this.showsort == 1) { this.$message.error("请先选择终止排序"); return false; }

      this.sellverifyLoading = true;
      this.create.act = 'verifyorder';
      this.create.type = 'verify';
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.sellverifyLoading = false;
        } else {
          const result = JSON.parse(Base64.decode(res.data.Data));
          if (result.error_msg) {
            this.$message.success(result.error_msg);

          } else {

            this.$message.success('保存订单信息成功，请前往销售订单中查看订单信息!');
          }
          this.$emit('closechild', 'Selledit'); //关闭窗口
        }
      }).catch((res) => {
        this.sellverifyLoading = false;
      });
    },

    //订单确认审核并打印
    verifyorderandprint() {
      if (this.showsort == 1) { this.$message.error("请先选择终止排序"); return false; }

      this.sellverifyprintLoading = true;
      this.create.act = 'verifyorder';
      this.create.type = 'verify';
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.sellverifyprintLoading = false;
        } else {
          const result = JSON.parse(Base64.decode(res.data.Data));
          if (result.error_msg) {
            this.$message.success(result.error_msg);
            return
          }
          this.sellverifyprintLoading = false;
          this.addandeditsellDialog = false;
          //重置订单数据信息    	
          this.create.id = '';
          this.create.deliverdate = '';
          this.create.account = '';
          this.create.note = '';
          this.create.total = '';
          this.create.derate = 0.00;
          this.create.express = 0.00;
          this.create.seller = this.sellerLists[0].id;
          this.create.customer = '';
          this.create.verifyer = '';
          this.create.shipping = '1';
          this.create.shippingcode = '';
          this.create.status = 0;
          this.create.carttype = 1;
          this.search.customer = '';

          //提取打印模板信息
          this.getprintsmodel(result.id);

          //调用打印
          this.showorder(result);
          this.$message.success('保存订单信息成功!');
        }
      }).catch((res) => {
        this.sellverifyprintLoading = false;
      }).finally(() => {
        this.sellverifyprintLoading = false;
      });
    },

    //删除订单信息
    delorder() {
      this.$confirm('您是否确定删除该未审核的订单，继续?', '提示', { type: 'warning' }).then(() => {
        this.selldelLoading = true;
        this.create.act = 'delorder';
        var resource = this.$resource(this.url);
        resource.query(this.create).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.selldelLoading = false;
          } else {
            this.$message.success('删除订单信息成功!');
            this.$emit('closechild', 'Selledit'); //关闭窗口
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },


    //展示打印确认页
    showorder(item) {
      this.getprintdetail(item.id);
    },


    //获取订单打印信息
    getprintdetail(id) {
      this.printerDialog = true;
      this.printLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getprintinfos', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printorderdetail = JSON.parse(Base64.decode(res.data.Data));
          //对商品进行分页设置
          var number = this.rollpage; //系统设置的每页条数
          this.prtotal = this.printorderdetail.goods.length; //总条数
          this.prpage = [];
          this.prollpage = [];

          if (number >= this.prtotal) {
            this.prpage.push({ id: 1 });
            this.prollpage.push({ startpage: 0, endpage: number });
            this.allprintpage = 1;
          } else {
            var tnumber = parseInt(this.prtotal / number);
            var lnumber = this.prtotal % number;
            var index;
            var start;
            var end;
            lnumber > 0 ? tnumber++ : '';
            this.allprintpage = tnumber;
            for (var i = 0; i < tnumber; i++) {
              index = i + 1;
              this.prpage.push({ id: index });
              start = i * number;
              end = index * number - 1;
              this.prollpage.push({ startpage: start, endpage: end });
            }
          }

          this.printLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.printLoading = false;
      });
    },

    /** 修改每页条数 **/
    changepagevlaue() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'changepagesize', id: 89, num: this.rollpage, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.changepage();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 设置分页设置 **/
    changepage() {
      this.printLoading = true;
      var number = this.rollpage; //系统设置的每页条数
      this.prtotal = this.printorderdetail.goods.length; //总条数
      this.prpage = [];
      this.prollpage = [];

      if (number >= this.prtotal) {
        this.prpage.push({ id: 1 });
        this.prollpage.push({ startpage: 0, endpage: number });
        this.allprintpage = 1;
      } else {
        var tnumber = parseInt(this.prtotal / number);
        var lnumber = this.prtotal % number;
        var index;
        var start;
        var end;
        lnumber > 0 ? tnumber++ : '';
        this.allprintpage = tnumber;

        for (var i = 0; i < tnumber; i++) {
          index = i + 1;
          this.prpage.push({ id: index });
          start = i * number;
          end = index * number - 1;
          this.prollpage.push({ startpage: start, endpage: end });
        }
      }

      this.printLoading = false;
    },

    /** 订单信息打印 **/
    createnoSave() {
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'updateprintnumber', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          this.printlocalpage(); //打印 
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },

    /** 打印当前页面 **/
    printlocalpage() {
      //设置打印信息
      var div_print = document.getElementById('printContent');
      var newStr = div_print.innerHTML;
      var oldStr = document.body.innerHTML;
      document.body.innerHTML = newStr;
      window.print();
      document.body.innerHTML = oldStr;

      this.$emit('closechild', 'Selledit'); //关闭窗口	    
      location.reload();
    },

    closeprint() {
      this.printerDialog = false;
      this.$emit('closechild', 'Selledit'); //关闭窗口	   
    },

    /** 关闭温馨提示窗口 **/
    Closeaccountwarn() {
      this.isopenaccount = 0;
    },


    /** 获取店铺信息 **/
    getsearchcustomers() {
      this.mergecustomerDialog = true;
      this.mergecustomerquery.key = '';
      this.mergecustomerquery.p = 1;
      this.mergecustomerquery.rollpage = 10;
      this.getmergecustomerdata();
    },

    /** 获取合并的客户信息列表 **/
    getmergecustomerdata() {
      if (this.mergechange) {
        this.mergecustomerquery.p = 1;
        this.mergecustomerquery.rollpage = 10;
      }

      this.mergecustomerquery.loading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
      resource.save(this.mergecustomerquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.mergecustomerquery.loading = false;
        } else {
          this.mergecustomerlists = JSON.parse(Base64.decode(res.data.Data));
          this.merge_rows = parseInt(res.data.count);
          this.mergecustomerquery.loading = false;
          if (this.mergechange) this.mergechange = false;
        }
      }).catch((res) => {
        this.mergecustomerquery.loading = false;
      });
    },

    mergepageSizeChange(val) {
      this.mergecustomerquery.rollpage = val;
      this.getmergecustomerdata();
    },
    mergepageCurrentChange(val) {
      this.mergecustomerquery.p = val;
      this.getmergecustomerdata();
    },

    /** 选择客户 **/
    selectcustomer(item) {
      var _this = this;
      this.search.customername = item.name;
      this.search.customer = item.id;

      this.create.customer = this.search.customer;
      this.query.customerid = this.search.customer;
      this.productquery.customerid = this.search.customer;
      this.query.searchcustomerid = 1;
      var clerkid = '';
      this.mergecustomerDialog = false;

      //自动根据客户匹配绑定的销售员
      var _this = this;
      clerkid = item.clerkid;
      this.sellerLists.forEach(function (item, i) {
        if (item.id == clerkid) _this.create.seller = clerkid;
      });
      this.getLists(); //刷新购物车界面
      this.getCustomer(item.name);
    },

    /** h5删除选中客户信息 **/
    delcustomer() {
      var _this = this;
      this.search.customername = '';
      this.search.customer = '';

      this.create.customer = this.search.customer;
      this.query.customerid = this.search.customer;
      this.productquery.customerid = this.search.customer;
      this.query.searchcustomerid = 1;
      var clerkid = '';

      this.getLists(); //刷新购物车界面
    },

    /** 获取打印设置信息 **/
    settingprints(item) {
      this.printsettingDialog = true;
      var _this = this;
      setTimeout(function () {
        _this.printclass['margin-right'] = '0%';
      }, 200);

      this.printmadequery.loading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.save({ act: 'getsellprints', token: this.$cookies.get('token'), id: item.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printmadequery.loading = false;
        } else {
          this.printmadequery.id = item.id;
          this.printmadequery.customername = item.customerName;
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.printmadequery.data = result;
          this.printmadequery.loading = false;
        }
      }).catch((res) => {
        this.printmadequery.loading = false;
      });
    },


    /** 保存打印设置信息 **/
    saveprintmade() {
      var _this = this;
      var data = [];
      this.printmadequery.data.forEach(function (item, i) {
        data.push(item);
      });
      data = JSON.stringify(data);
      this.printmadequery.loading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.save({ act: 'savesellprints', token: this.$cookies.get('token'), id: this.printmadequery.id, data: data }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printmadequery.loading = false;
        } else {
          this.printmadequery.loading = false;
          //关闭窗口
          this.closeprinters();
          //刷新打印数据模板信息
          this.getprintsmodel(this.printmadequery.id);
          //刷新打印数据
          this.getprintdetail(this.printmadequery.id);
        }
      }).catch((res) => {
        this.printmadequery.loading = false;
      });
    },


    /** 关闭打印设置窗口 **/
    closeprinters() {
      this.printclass['margin-right'] = '-20%';
      var _this = this;
      setTimeout(function () {
        _this.printsettingDialog = false;
      }, 500);
    },


    /******** 批量设置商品仓库信息 *********/
    //level（all、全部商品信息重置，empty、还没有设置仓库的商品）
    //type（1、新增商品 2、编辑商品）
    settingwarehouse_from_add(level, type) {
      var title = '';
      level == 'all' ?
        title = '该操作会将下面所有商品按出库规则顺序进行出库仓库设置，且当商品无库存时将不设置出库仓库，且操作后不可撤回，是否继续？' :
        title = '该操作会将下面所有（未设置仓库）商品按出库规则从大到小的顺序进行设置，且当商品无库存时将不设置出库仓库，且操作后不可撤回，是否继续？'

      this.$confirm(title, '提示', { type: 'warning' }).then(() => {
        this.listLoading = true;
        var resource = this.$resource(this.GLOBAL.domain + "Sell/index");
        resource.save({ act: 'settingwarehouse_to_sell', token: this.$cookies.get('token'), level: level, type: type, id: this.childdata.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.listLoading = false;
          } else {
            this.listLoading = false;
            this.getLists(); //刷新购物车界面
          }
        }).catch((res) => {
          this.listLoading = false;
        });

      }).catch(() => {

      });
    }




  }
}
</script>
<style type="text/css">
.click-ware-lists:hover {
  text-decoration: underline;
  cursor: pointer;
}

.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

#showselectgoods {
  display: none;
  position: fixed;
  width: 2%;
  height: 100%;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 10000;
}

#showselectgoods #selecttitle {
  width: 100%;
  float: left;
  color: #fff;
  text-align: center;
  font-size: 15px;
  padding: 20px 0 20px 0;
  font-size: 15px
}

#showselectgoods #selectdata {
  display: none
}

#showselectgoods:hover {
  width: 30%;
  background-color: #FFF;
  box-shadow: #000 10px 10px 35px;
  transition: width 0.5s;
}

#showselectgoods:hover #selecttitle {
  color: #606266;
  font-size: 13px
}

#showselectgoods:hover #selectdata {
  display: block;
  width: 90%;
  margin-top: 20px;
  margin-left: 5%;
  height: 85%;
  overflow: auto
}

.search-customer-h5 {
  height: 32px;
  line-height: 32px;
  padding-right: 30px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
  font-size: 13px;
  overflow: hidden
}

.printsetting {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
  overflow: hidden;
  transition: .3s all;
  background: rgba(0, 0, 0, 0.6)
}

.printsetting .printmain {
  width: 20%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: #dddddd;
  border-radius: 15px 0 0 15px;
  border-left: 1px solid #dddddd;
  overflow-y: scroll;
  box-shadow: -2px 0 20px #000000;
  transition: .5s all;
}

.printsetting .printmain::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.printin {
  width: 90%;
  height: 96%;
  margin: 2% 0 0 5%;
  background: #dddddd
}

.printin .el-form-item__label {
  font-size: 13px
}


.cz-sell-order-verifys {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 10px;
  width: calc(100% - 2px - 40px);
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid #fde2e2;
  background: #fef0f0;
}

.cz-sell-order-verifys i {
  width: 15px;
  height: 15px;
  background: url(../../assets/gantanhao.png) no-repeat;
  background-size: 15px 15px;
  background-position: center center;
  margin-right: 10px;
}

.cz-sell-order-verifys span {
  color: #f56c6c;
  font-size: 12px;
  line-height: 12px;
}

.cz-sell-order-verifys a {
  cursor: pointer;
  width: 15px;
  height: 15px;
  background: url(../../assets/error_sell.png) no-repeat;
  background-size: 15px 15px;
  background-position: center center;
  margin-left: 10px;
}

.cz-sell-base-lists-infos-out {
  display: inline-block;
  width: 100%;
}

.cz-sell-base-lists-infos {
  float: left;
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 0;
  width: 25%;
  height: 50px;
  overflow: hidden;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {
  float: left;
  text-align: right;
  font-size: 13px;
  line-height: 23px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {
  float: left;
  margin-left: 10px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {
  text-align: left;
  width: 220px;
  border-bottom: 1px solid #dcdfe6;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {
  box-shadow: none;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {
  margin-top: 7px
}

.cz-sell-base-lists-infos-goods {
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}

.cz-sell-base-lists-infos-goods .el-table {
  font-size: 13px;
}

.cz-sell-base-lists-infos-goods .el-table th.is-leaf {
  background: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table td,
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {
  border-bottom: 1px solid #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,
.cz-sell-base-lists-infos-goods .el-table .hover-row>td {
  background-color: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {
  background: #E4E7ED;
  border-bottom: 1px solid #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border-bottom: none;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}

.cz-sell-base-lists-infos-goods .el-input__inner:hover {
  box-shadow: none;
  border: none;
}

.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td,
.cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {
  background-color: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #E4E7ED;
}

.cz-sell-order-stat {
  width: calc(100%);
  height: 100px;
  position: relative;
  margin-top: 10px;
  margin-bottom: 20px;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cz-sell-order-stat-handles {
  padding: 10px 20px;
  height: 60px;
  border-left: 1px solid #EBEEF5;
  width: 30%;
  display: flex;
  justify-content: left;
  align-items: center;
  overflow: hidden;
}

.cz-sell-order-stat-totals {
  padding: 10px 20px;
  height: 100px;
  width: calc(100% - 30% - 40px - 40px - 1px);
  display: flex;
  justify-content: left;
  align-items: center;
  overflow: hidden;
}

.cz-sell-order-stat-totals-name {
  float: left;
  width: calc(25% - 30px) !important;
  padding: 3px 30px 0 0 !important;
  font-size: 13px;
}

.cz-sell-order-stat-totals-name-title {
  float: left;
  width: 80px;
}

.cz-sell-order-stat-totals-name-content {
  float: left;
  width: calc(100% - 100px - 10px - 30px);
  padding: 0 15px;
  color: red;
  font-weight: 550;
  font-size: 14px;
}

.cz-sell-order-stat-totals-name .el-input {
  width: calc(100% - 80px - 5px);
  font-size: 14px;
}

.cz-sell-order-stat-totals-name .el-input__inner {
  color: red;
  font-weight: 550;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border-bottom: 1px solid #c0c4cc !important;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
  background: none;
  text-align: left;
}

.cz-sell-order-stat-totals-name .el-input__inner:hover {
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #c0c4cc !important;
  background: none;
}

.cz-sell-order-stat-totals-name .el-input.is-active .el-input__inner,
.cz-sell-order-stat-totals-name .el-input__inner:focus {
  border-color: #c0c4cc !important;
  background: none;
}

.cz-sell-order-sort {
  background: #fff;
  width: 98%;
  float: left;
  margin-top: 10px;
  padding: 1% 1% 1% 1%;
  border-radius: 5px;
}

.cz-sell-order-sort .dargDiv {
  float: left;
  width: 100%;
  border-bottom: 1px dashed #dddddd;
  font-size: 14px;
  line-height: 23px
}

.cz-sell-order-sort .dargDiv .cz-sell-order-sort-infos {
  color: #666666;
  cursor: pointer;
  font-size: 13px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cz-sell-order-sort .dargDiv:hover {
  background: rgb(254, 240, 240);
}

.cz-sell-base-lists-infos-goods .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.cz-sell-base-lists-infos-goods .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 15px;
  -webkit-box-shadow: inset 0 0 5px rgba(220, 223, 230, 0.2);
  background: rgba(96, 98, 102, 0.4);
}

.cz-sell-base-lists-infos-goods .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(153, 153, 153, 0.2);
  border-radius: 0;
  background: rgba(153, 153, 153, 0.1);
}

@media screen and (min-width: 0px) and (max-width: 850px) {
  .sell-bottom-show .el-col-6 {
    width: 100% !important
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/Selledit.vue